<script>
import { getCar } from '@/api/car'
import { get as getOffer } from '@/api/offer'
import { getSellMovementData, sell } from '@/api/cars'
import SellCarForm from '@/components/cars/edit/forms/disposition/SellCarForm.vue'
import ClipboardFin from '@/components/cars/edit/ClipboardFin.vue'
import ClipboardCommissionNumber from '@/components/cars/edit/ClipboardCommissionNumber.vue'
import LabelledText from '@/components/cars/edit/LabelledText.vue'
import PageHeader from '@/components/cars/edit/PageHeader.vue'
import Status from '@/components/cars/edit/Status.vue'
import PageHeaderActionButton from '@/components/cars/edit/PageHeaderActionButton.vue'
import CarCalculation from '@/components/cars/CarCalculation.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import grossPrice from '@/filters/gross-price'
import CalculatesVat from '@/mixins/CalculatesVat'
import BlockedNotice from '@/components/cars/edit/BlockedNotice.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'
import car from '@/helpers/car'

export default {
  components: {
    'mia-blocked-notice': BlockedNotice,
    'mia-car-calculation': CarCalculation,
    'mia-car-edit-page-header-action-button': PageHeaderActionButton,
    'mia-car-edit-page-header': PageHeader,
    'mia-car-edit-status': Status,
    'mia-clipboard-commission-number': ClipboardCommissionNumber,
    'mia-clipboard-fin': ClipboardFin,
    'mia-labelled-text': LabelledText,
    'mia-notice': Notice,
    'mia-sell-car-form': SellCarForm
  },

  filters: {
    grossPrice
  },

  mixins: [CalculatesVat, HandlesBackendValidationErrors],

  data: () => ({
    showCalculation: false,
    car: null,
    offer: null,
    form: {
      item_car_id: null,
      item_offer_id: null,
      item_seller_id: null,
      item_assignee_id: null,
      item_customer_id: null,
      item_lead_process: null,
      item_contract_date: '',
      item_numberplate: '',
      item_status: '',
      item_sold_channel: '',
      item_price_sold: '',
      item_customer_type: '',
      item_payment_method: '',
      item_ksb: 'N',
      item_bank: '',
      item_loan: '',
      item_financing_term: '',
      item_bdk_registration_date: '',
      item_survey: 'Y',
      item_expected_dispatch: '',
      item_delivery_type: '',
      item_insurance_sold: 'N',
      item_provision_remark: '',
      item_customer_portal_onboarding: 'Y',
      item_price_purchased: '',
      customer_portal: {
        item_payment_method: 'no_choice',
        item_delivery_package: 'no_choice',
        item_is_delivery_package_free: 'N',
        item_registration_package: 'no_choice',
        item_is_registration_package_free: 'N',
        item_registration_district: '',
        item_tyre_package: 'no_choice',
        item_is_tyre_package_free: 'N',
        item_tyre_quality: '',
        item_rim_material: '',
        item_aluminum_rim_color: '',
        item_aluminum_rim_type: '',
        item_aluminum_rim_design: ''
      },
      required_documents: []
    },
    existingSellMovement: null,
    vat: 0.19
  }),

  computed: {
    carId() {
      return this.$route.params.carId
    },

    offerId() {
      return this.$route.query.offerId || null
    }
  },

  async created() {
    this.$wait.start('loading car')

    if (this.carId > 0) {
      this.car = await getCar({
        carId: this.carId
      })
    }

    if (this.offerId > 0) {
      this.offer = await getOffer(this.offerId)
    }

    const [error, response] = await getSellMovementData(this.carId)

    if (!error) {
      this.existingSellMovement = response.data.existingSellMovement
      this.vat = response.data.vat
    }

    this.initForm()
    this.$wait.end('loading car')
  },

  mounted() {
    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/legacy/cars'
        },
        text: 'Fahrzeuge verwalten'
      },
      {
        link: {
          path: `/cars/${this.carId}/verkaufsmeldung`
        },
        text: 'Verkaufsmeldung erstellen'
      }
    ])
  },

  methods: {
    initForm() {
      this.$set(this.form, 'item_car_id', this.carId)
      this.$set(this.form, 'item_offer_id', this.offerId)
    },

    async onSubmit() {
      if (this.$wait.is('selling car')) {
        return
      }

      this.$wait.start('selling car')
      let payload = this.form

      if (this.offerId) {
        payload = new FormData()

        Object.entries(this.form).forEach(([key, value]) => {
          let val = value

          if (val === null) {
            val = ''
          }

          if (key === 'required_documents') {
            val.forEach((v, index) => {
              payload.append(`${key}[${index}][item_document]`, v.file)
              payload.append(`${key}[${index}][item_category_id]`, v.category.id)
            })
          } else if (Array.isArray(val)) {
            val.forEach((v) => {
              payload.append(`${key}[]`, v)
            })
          } else if (typeof val === 'object') {
            Object.entries(val).forEach(([k, v]) => {
              payload.append(`${k}[]`, v)
            })
          }
        })
      }

      const [error, response] = await sell(payload)
      this.$wait.end('selling car')

      if (error) {
        this.handleBackendValidationErrors(error)
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Erstellen der Verkaufsmeldung. Bitte prüfen Sie Ihre Eingaben.']
        })
        return
      }

      console.log(response)
    }
  }
}
</script>

<template>
  <div class="w-full">
    <mia-wait for="loading car">
      <template #waiting>
        <div class="flex items-center justify-center py-8">
          <mia-wave-loader />
        </div>
      </template>

      <template #default>
        <mia-car-edit-page-header
          class="px-4 pt-6 pb-16 rounded-md overflow-hidden relative"
          title="Verkaufsmeldung erstellen"
        >
          <template #info>
            <div class="grid grid-cols-2 grid-rows-2 gap-4">
              <template v-if="car">
                <mia-labelled-text label="Fahrzeug-ID">
                  {{ car.id }}
                </mia-labelled-text>
                <mia-labelled-text label="Status">
                  <mia-car-edit-status :status="car.item_status" />
                </mia-labelled-text>
                <mia-clipboard-fin :fin="car.item_fin" />
                <mia-clipboard-commission-number :commission-number="car.item_commission_number" />
              </template>
              <template v-else>
                <mia-labelled-text label="Konfigurations-ID">
                  {{ offer.item_configuration.externalId || 'Unbekannt' }}
                </mia-labelled-text>
                <mia-labelled-text label="Fahrzeug">
                  {{ offer.item_configuration.maker }} {{ offer.item_configuration.model }} {{ offer.item_configuration.line }}<br><small>{{ offer.item_configuration.title }}</small>
                </mia-labelled-text>
              </template>
            </div>

            <div class="absolute bottom-0 mb-4 right-0 mr-5">
              <router-link
                :to="`/legacy/car_sell/${carId || '0'}${offerId ? `/${offerId}` : ''}`"
                class="text-orange-mia hover:text-orange-mia-dark hover:underline"
              >
                Zum alten Fahrzeug verkaufen UI »
              </router-link>
            </div>
          </template>

          <template #actions>
            <mia-is-allowed to="show_calculation">
              <div class="flex flex-col items-end">
                <mia-car-edit-page-header-action-button @click="showCalculation = !showCalculation">
                  Preiskalkulation {{ showCalculation ? 'ausblenden' : 'anzeigen' }}
                </mia-car-edit-page-header-action-button>

                <mia-car-calculation
                  v-show="showCalculation"
                  class="mt-4"
                />
              </div>
            </mia-is-allowed>
          </template>
        </mia-car-edit-page-header>

        <mia-notice
          v-if="existingSellMovement"
          permanent
          type="error"
          class="mt-4"
        >
          <p><strong>Achtung!</strong> Für dieses Fahrzeug wurde bereits eine Verkaufsmeldung erstellt. Das Fahrzeug kann nicht erneut verkauft werden.</p>
          <p>Bitte bearbeiten oder löschen Sie zunächst die bestehende Verkaufsmeldung.</p>
          <p class="mb-0 mt-4">
            <router-link
              :to="`/cars/${car.id}`"
              class="text-orange-mia-dark hover:underline"
            >
              « Zurück zum Fahrzeug
            </router-link>
            <span> | </span>
            <router-link
              :to="`/legacy/car_move_edit/${existingSellMovement.id}`"
              class="text-orange-mia-dark hover:underline"
            >
              Bestehende Verkaufsmeldung bearbeiten »
            </router-link>
          </p>
        </mia-notice>
        <template v-else>
          <mia-notice
            v-if="!car"
            permanent
            type="info"
            class="mt-4"
          >
            <div class="flex-1 pr-4">
              <h3 class="py-0 my-0 mb-2 text-lg text-blue-800">
                Konfiguriertes Fahrzeug
              </h3>
              <p class="leading-5 mb-0">
                <mia-streamline-icon
                  class="inline-block w-5 h-5 -mt-1 mr-2 text-blue-700 fill-current"
                  src="information-circle"
                />
                Wenn Sie dieses Fahrzeug verkaufen, wird es in Ihren Bestand importiert.
              </p>
            </div>
          </mia-notice>
          <mia-notice
            v-else-if="car && !car.own_car"
            permanent
            type="info"
            class="mt-4"
          >
            <div class="flex justify-between">
              <div class="flex-1 pr-4">
                <h3 class="py-0 my-0 mb-2 text-lg text-blue-800">
                  Bereitgestelltes Fahrzeug
                </h3>
                <p class="leading-5">
                  <mia-streamline-icon
                    class="inline-block w-5 h-5 -mt-1 text-blue-700 fill-current"
                    src="information-circle"
                  />
                  Dieses Fahrzeug wird Ihnen von <strong>{{ car.forgein_dealer.item_name }}</strong> zur Verfügung gestellt.<br>
                  Sie können dieses Fahrzeug verkaufen. Dabei wird das Fahrzeug in Ihren Bestand importiert und kann anschließend frei bearbeitet werden.
                </p>
              </div>

              <div class="w-1/3">
                <div class="overflow-hidden bg-white rounded-lg shadow">
                  <div class="p-3">
                    <dl class="mb-0">
                      <dt class="text-sm font-medium leading-5 text-gray-600 truncate">
                        UPE
                      </dt>
                      <dd

                        class="mt-1 text-xl font-semibold leading-7 text-gray-800"
                      >
                        <span>{{ car.item_net_list_price | grossPrice }}</span><small class="ml-1 text-sm font-normal">Brutto</small><br>
                        <span class="text-lg">{{ car.item_net_list_price | price }}</span><small class="ml-1 text-sm font-normal">Netto</small>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </mia-notice>

          <mia-blocked-notice
            v-if="car && car.item_blocked_id !== null"
            :car="car"
            class="mt-4"
          />

          <mia-sell-car-form
            v-model="form"
            :car="car"
            :offer="offer"
            :vat="vat"
            :errors-key="backendValidationErrorsKey"
            class="mt-4"
            :with-customer-portal-form="!offerId && car.own_car"
            :with-provisions-form="!offerId && car.own_car"
            @submit="onSubmit"
          />
        </template>
      </template>
    </mia-wait>
  </div>
</template>
